module.exports = __webpack_public_path__ + "img/a1.cbba3e98.jpg";